/**
 * Mobile header counter badges (wishlist/cart): hide the badge entirely at
 * a zero count instead of showing "0". Deliberately does not touch
 * wpbingo.js — it observes the rendered text of the existing counter
 * elements instead of duplicating wishlist/cart business logic, so it
 * stays correct no matter which code path updates the count (initial
 * Liquid render, wpbingo.js's AJAX cart callback, wishlist localStorage
 * sync, or a future change to either).
 */
(function () {
  'use strict';

  function syncZeroState(el) {
    if (!el) return;
    var text = (el.textContent || '').trim();
    el.classList.toggle('is-zero', text === '' || text === '0');
  }

  function watch(el) {
    if (!el || el.dataset.evZeroWatched === 'true') return;
    el.dataset.evZeroWatched = 'true';
    syncZeroState(el);
    new MutationObserver(function () {
      syncZeroState(el);
    }).observe(el, { childList: true, characterData: true, subtree: true });
  }

  function init() {
    document
      .querySelectorAll(
        '.header-mobile [data-count-wishlist] .count, .header-mobile .header-cart__count'
      )
      .forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
